import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FolderIcon } from 'assets/icon-folder.svg';

import { EmptyWrapper } from './styles';

const EmptyCustomFolder = () => {
  const { t } = useTranslation();
  return (
    <EmptyWrapper>
      <FolderIcon />
      <span>{t('custom_folder_not_found')}</span>
    </EmptyWrapper>
  );
};
export default EmptyCustomFolder;
